package com.exura.features.demosets.domain.usecase

import com.exura.features.demosets.domain.DemoSetsConstants
import com.exura.features.demosets.domain.model.DemoSet
import com.exura.features.demosets.domain.model.ListDemoSetsResponse
import dev.gitlive.firebase.functions.FirebaseFunctions

class ListDemoSetsUseCase(
    private val functions: FirebaseFunctions,
) {

    suspend operator fun invoke(): Result<List<DemoSet>> = runCatching {
        val listCallable = functions.httpsCallable(DemoSetsConstants.Functions.LIST_DEMO_SETS)

        val result = listCallable()
        val response = result.data<ListDemoSetsResponse>()

        if (response.success) {
            response.demoSets.toList()
        } else {
            throw Exception(response.message ?: "Failed to list demo sets")
        }
    }
}
